<template>
    <div>
        <div class="columns">
            <div class="column">
                <div class="buttons">
                    <button class="button is-primary" @click="openAddCouponModal">
                        <span class="icon"><i class="fas fa-plus"></i></span>
                        <span>{{ translate("coupons.add_new") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <CouponListing :event-id="eventId" ref="couponListing" @edit-coupon="openEditCouponModal" @view-usage="viewUsageDetails" />
        <CouponModal :event-id="eventId" :event-timezone="eventTimezone" ref="couponModal" @saved="refreshListing" />
        <CouponUsageModal :event-id="eventId" :event-timezone="eventTimezone" ref="couponUsageModal" />
    </div>
</template>

<script setup lang="ts">
    import { ref } from "vue";
    import { translate } from "../../Common/translations";
    import CouponListing from "./CouponListing.vue";
    import CouponModal from "./CouponModal.vue";
    import CouponUsageModal from "./CouponUsageModal.vue";
    import type { Coupon } from "../../Api/coupons";

    defineProps<{
        eventId: number;
        eventTimezone: string;
    }>();

    const couponListing = ref<InstanceType<typeof CouponListing> | null>(null);
    const couponModal = ref<InstanceType<typeof CouponModal> | null>(null);
    const couponUsageModal = ref<InstanceType<typeof CouponUsageModal> | null>(null);

    const openAddCouponModal = () => {
        couponModal.value?.open();
    };

    const openEditCouponModal = (coupon: Coupon) => {
        couponModal.value?.openForEdit(coupon);
    };

    const viewUsageDetails = (coupon: Coupon) => {
        couponUsageModal.value?.open(coupon);
    };

    const refreshListing = () => {
        couponListing.value?.refresh();
    };
</script>

<style scoped></style>
